"use client";

import { SectionTitle } from "./sectionTitle";

export const Contact = () => {
	return (
		<div className="flex flex-col gap-4">
			<div className="mt-2">
				<SectionTitle title="問い合わせ先" />
			</div>

			<p className="text-black font-bold font-zenMaru text-xl text-left">
				株式会社プロッセル
				<br />
				oncon@prossell.jp
			</p>
		</div>
	);
};
